import { render } from "./fish.vue?vue&type=template&id=1d26cb9e"
import script from "./fish.vue?vue&type=script&lang=js"
export * from "./fish.vue?vue&type=script&lang=js"

import "./fish.vue?vue&type=style&index=0&id=1d26cb9e&lang=css"
script.render = render

export default script